import React from 'react'
import styled from '@emotion/styled'

import {Link} from '@vio/atlas/Link'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const AgreementWrapper = styled.div`
  margin-top: ${cssTheme.layout.spacing.s500};
  text-align: center;
`

export const Agreement = () => {
  const {brand} = useBrand()
  return (
    <AgreementWrapper>
      <Text variant="bodyXS" colorPath="content.neutral.secondary">
        <FormattedMessageWrapper
          id="magicLinkModal.agreementMessage"
          defaultMessage="By continuing, you agree with our <TermsOfUse></TermsOfUse> and <PrivacyPolicy></PrivacyPolicy>."
          values={{
            TermsOfUse: () => (
              <Link
                href={brand?.links?.termsOfUseUrl}
                target="_blank"
                rel="noreferrer"
                variant="secondary"
              >
                <FormattedMessageWrapper
                  id="termsOfUse"
                  defaultMessage="Terms of Use"
                />
              </Link>
            ),
            PrivacyPolicy: () => (
              <Link
                href={brand?.links?.privacyPolicyUrl}
                target="_blank"
                rel="noreferrer"
                variant="secondary"
              >
                <FormattedMessageWrapper
                  id="privacyPolicy"
                  defaultMessage="Privacy Policy"
                />
              </Link>
            )
          }}
        />
      </Text>
    </AgreementWrapper>
  )
}
